// components/Protected.jsx


import { Button, Table, TableHead, TableRow, TableCell, TableBody} from '@aws-amplify/ui-react';
import {React,  useState } from 'react';
import { Col, Row } from 'react-bootstrap';


import { DatePicker } from 'react-widgets/cjs';
import "../App.css";
import "react-widgets/scss/styles.scss";

import { calculateBiorhythmResults,percentage } from './BioFunctionsQC';

export function Protected() {

  const [startDate, setStartDate] = useState(null);
  const [targetDate, setTargetDate] = useState(null);


  const DOB = () => {
    
    return (

      <DatePicker
        placeholder="mm/dd/yyyy"
        defaultValue={startDate}
        valueFormat={{ dateStyle: "medium" }}
        onChange={date => setStartDate(date)}
      />
    );
  };
  
  const TargetDate = () => {
    return (
  
     <DatePicker 
     placeholder="mm/dd/yyyy"
     defaultValue={targetDate}
     valueFormat={{ dateStyle: "medium" }}
     onChange={date => setTargetDate(date)} 
     />

    );
  };

  const getBioDesc = (bio)=>{
    return bio > 0.5 ? "High" : (bio < -0.5 ? "Low" :(bio>=-0.5 && bio < 0 ? "Medium Neg " : "Medium Pos" )); 
  }

  function CalculateBio(){
    console.log("CalculateBio");
   // alert(dobTestRef.current.value)
    //setStartDate(new Date(dobTestRef.current.value));

   
    const physicalCell     = document.getElementById("physical");
    const descPhysical     = document.getElementById("physicaldesc");
    const emotionalCell    = document.getElementById("emotional");
    const descEmotional    = document.getElementById("emotionaldesc");
    const intellectualCell = document.getElementById("intellectual");
    const descIntellectual = document.getElementById("intellectualdesc");
    const instictualCell   = document.getElementById("instictual");
    const descInstictual   = document.getElementById("instictualdesc");
    const average          = document.getElementById("average");
    const descAverage      = document.getElementById("averagedesc");
    const moonPhase        = document.getElementById("moonphase");
    const targetMoonPhase  = document.getElementById("targetmoonphase");
 
    if (startDate && targetDate){
        const results = calculateBiorhythmResults(startDate, targetDate);
        console.log("It reached here");
        let physical     = results.physical;
        let emotional    = results.emotional;
        let intellectual = results.intellectual;
        let instictual   = results.instinctual;
        let avg          = results.average;

        physicalCell.innerHTML      = percentage(physical);
        descPhysical.innerHTML      = getBioDesc(physical);
        emotionalCell.innerHTML     = percentage(emotional);
        descEmotional.innerHTML     = getBioDesc(emotional);
        intellectualCell.innerHTML  = percentage(intellectual);
        descIntellectual.innerHTML  = getBioDesc(intellectual);
        instictualCell.innerHTML    = percentage(instictual);
        descInstictual.innerHTML    = getBioDesc(instictual);
        average.innerHTML           = percentage(avg);
        descAverage.innerHTML       = getBioDesc(avg);

        moonPhase.innerHTML         = results.birthMoon.name;
        targetMoonPhase.innerHTML   = results.targetMoon.name;
    }
  }

  function QuickCheck(){
    return (
        <>
        <Row>
          <Col lg={2}>
          </Col>
          <Col>
          <label> Select Birth Date</label> < DOB />  
          <label> Select Target Date</label> < TargetDate />
          <Button backgroundColor={'#fef7e5'} ariaLabel="" onClick={CalculateBio} isFullWidth={true} fontSize={'3rem'}>
            Calculate Biorythim
          </Button>
        <Table highlightOnHover={true} backgroundColor={'rgba(255,255,255,0.3)'} >
            <TableHead>
                <TableRow >
                    <TableCell   backgroundColor={'#FF7F7F'}>
                        Phy
                    </TableCell>
                    <TableCell backgroundColor={'#90EE90'}>
                        Emo
                    </TableCell>
                    <TableCell backgroundColor={'#CBC3E3'}>
                        Int
                    </TableCell>
                    <TableCell backgroundColor={'#ffffe0'}>
                        Inst
                    </TableCell>
                   
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell id = "physical" />
                    <TableCell id = "emotional" /> 
                    <TableCell id = "intellectual" />
                    <TableCell id = "instictual" />
                    
                </TableRow>
                <TableRow>
                    <TableCell id = "physicaldesc" />
                    <TableCell id = "emotionaldesc" /> 
                    <TableCell id = "intellectualdesc" />
                    <TableCell id = "instictualdesc" />
                   
                </TableRow>
                <TableRow>
                  <TableCell  backgroundColor={'#D3D3D3'} colSpan={4}>
                    Average
                  </TableCell>
                </TableRow>
                <TableRow>
                <TableCell id = "average" colSpan={2}  />
                <TableCell id = "averagedesc" colSpan={2} />
              
                </TableRow>
          
                <TableRow>
                  <TableCell  backgroundColor={'#fef7e5'} colSpan={2} >
                    DOB Moon Phase
                  </TableCell>
                  <TableCell backgroundColor={'rgb(193, 154, 107)'} colSpan={2} >
                    Target Moon Phase
                  </TableCell>
                </TableRow>
                <TableRow>
                <TableCell id = "moonphase" colSpan={2} />
                <TableCell id = "targetmoonphase" colSpan={2} />
                </TableRow>
                
            </TableBody>
        </Table>
        </Col>
          <Col  lg={2}>
          </Col>
        </Row>
        

      </>
    )

  }

  return <QuickCheck />;
}
